import { render, staticRenderFns } from "./EditableTitle.vue?vue&type=template&id=b400e3e2&scoped=true&"
import script from "./EditableTitle.vue?vue&type=script&lang=js&"
export * from "./EditableTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b400e3e2",
  null
  
)

export default component.exports